enum ChatType {
  USER = 'user',
  GROUP = 'group',
  CONFERENCE = 'conference',
}

export default ChatType;
